import React, { useState } from "react";
import { LogOut, LayoutDashboard, Clock, Users, Store, CalendarRange, ClipboardCheck, Settings, ReceiptText, Wallet } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import BrandLogo from "@/components/BrandLogo";
import DashboardTab from "@/components/admin/DashboardTab";
import MasterShiftTab from "@/components/admin/MasterShiftTab";
import KaryawanTab from "@/components/admin/KaryawanTab";
import OutletTab from "@/components/admin/OutletTab";
import JadwalShiftTab from "@/components/admin/JadwalShiftTab";
import RiwayatTab from "@/components/admin/RiwayatTab";
import PengaturanTab from "@/components/admin/PengaturanTab";
import SlipGajiTab from "@/components/admin/SlipGajiTab";
import CicilanTab from "@/components/admin/CicilanTab";

const TABS = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "tab-dashboard", C: DashboardTab },
  { id: "master-shift", label: "Master Shift", icon: Clock, testid: "tab-master-shift", C: MasterShiftTab },
  { id: "karyawan", label: "Data Karyawan", icon: Users, testid: "tab-karyawan", C: KaryawanTab },
  { id: "cicilan", label: "Cicilan Karyawan", icon: Wallet, testid: "tab-cicilan", C: CicilanTab },
  { id: "outlet", label: "Data Outlet", icon: Store, testid: "tab-outlet", C: OutletTab },
  { id: "jadwal-shift", label: "Jadwal Shift", icon: CalendarRange, testid: "tab-jadwal-shift", C: JadwalShiftTab },
  { id: "riwayat-approval", label: "Riwayat & Approval", icon: ClipboardCheck, testid: "tab-riwayat-approval", C: RiwayatTab },
  { id: "slip-gaji", label: "Slip Gaji", icon: ReceiptText, testid: "tab-slip-gaji", C: SlipGajiTab },
  { id: "pengaturan", label: "Pengaturan", icon: Settings, testid: "tab-pengaturan", C: PengaturanTab },
];

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const [active, setActive] = useState("dashboard");
  const Active = TABS.find((t) => t.id === active).C;

  return (
    <div className="min-h-screen bg-[#F2EFE7] flex flex-col">
      <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-slate-200 no-print">
        <div className="px-4 sm:px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <BrandLogo className="h-10 w-10" testId="admin-brand-logo" />
            <div>
              <p className="font-bold text-slate-800 leading-tight">MLC Attendance</p>
              <p className="text-xs text-slate-400 leading-tight">Panel Admin</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-slate-500 hidden sm:inline">{user.name}</span>
            <button onClick={logout} data-testid="logout-button" className="text-slate-400 hover:text-rose-600 transition-colors">
              <LogOut className="h-5 w-5" />
            </button>
          </div>
        </div>
        <nav className="px-2 sm:px-4 flex gap-1 overflow-x-auto">
          {TABS.map((t) => {
            const Icon = t.icon;
            const on = active === t.id;
            return (
              <button key={t.id} data-testid={t.testid} onClick={() => setActive(t.id)}
                className={`flex items-center gap-1.5 whitespace-nowrap px-3 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                  on ? "border-sky-600 text-[#284f7a]" : "border-transparent text-slate-500 hover:text-slate-800"
                }`}>
                <Icon className="h-4 w-4" /> {t.label}
              </button>
            );
          })}
        </nav>
      </header>

      <main className="flex-1 px-4 sm:px-6 py-6 max-w-7xl w-full mx-auto">
        <Active />
      </main>
    </div>
  );
}
